import { trainingAPI } from "@api/TrainingAPI";

export const BANNER_SET_BANNERS = "BANNER_SET_BANNERS";

export const getBanners = () => async (dispatch: any) => {
    try {
        const data = await trainingAPI.getBanners();
        dispatch({ type: BANNER_SET_BANNERS, payload: data.banners });
    } catch {
        // Deliberately silent: banners are informational, and a login-time
        // toast for a flaky endpoint would be noise.
    }
};
